import { render } from "./table-col.vue?vue&type=template&id=c51a9b3a&scoped=true"
import script from "./table-col.vue?vue&type=script&lang=js"
export * from "./table-col.vue?vue&type=script&lang=js"

import "./table-col.vue?vue&type=style&index=0&id=c51a9b3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51a9b3a"]])

export default __exports__